import { render } from "./RegistrationInfoApproveEmail.vue?vue&type=template&id=0c1df48a&scoped=true"
import script from "./RegistrationInfoApproveEmail.vue?vue&type=script&lang=js"
export * from "./RegistrationInfoApproveEmail.vue?vue&type=script&lang=js"

import "./RegistrationInfoApproveEmail.vue?vue&type=style&index=0&id=0c1df48a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1df48a"]])

export default __exports__